<template>
  <div>
    <live-stream
      v-if="$can('read', 'live-stream') || $can('update', 'live-stream')"
      :channel="channel"
      :channel-options="channelOptions"
      :channel-item="channelItem"
    />
  </div>
</template>

<script>
import LiveStream from './liveStream/LiveStream.vue'

export default {
  components: {
    LiveStream,
  },
  props: {
    channel: {
      type: Number,
      default: 1,
    },
    channelOptions: {
      type: Array,
      default: () => [],
    },
    channelItem: {
      type: Object,
      default: () => ({}),
    },
  },
}
</script>
